import React, { useEffect, useState } from "react";
import "./contact-support.scss";
import StarRating from "../star-rating/star-rating";
import axios from "axios";
import { toast } from "react-toastify";
import {
  IUserSessionInfo,
  userSessionStateSelector,
} from "../../redux/reducers/user-session/userSessionSlice";
import { useAppSelector } from "../../hooks/typed-hooks";
import TrowelIcon from "../icon";
import supportIcon from "../../assets/media/icons/supportIcon.png"
import sendMessageIcon from "../../assets/media/icons/sendMessageSmall.png"
import infoIcon from "../../assets/media/icons/infoBlueSmall.png"

interface ContactSupportFormProps {
  onClose: () => void;
}

const ContactSupportForm: React.FC<ContactSupportFormProps> = ({ onClose }) => {
  
  let apiUrlBase = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  // Ensure apiUrl ends with a slash
  if (!apiUrlBase.endsWith('/')) {
    apiUrlBase += '/';
  }

  // let apiUrlBase: string | undefined = process.env.REACT_APP_API_URL;
  // if (!apiUrlBase) {
  //   // Fallback value for prod environment
  //   apiUrlBase = "https://trowelwa01.azurewebsites.net/";
  // }

  const [supportData, setSupportData] = useState({
    issueType: "",
    issueDescription: ""
  });
  const [error, setError] = useState<string>("");
  const [userSessionInfo, setUserSessionInfo] =
    useState<IUserSessionInfo | null>(null);
  const userSessionState = useAppSelector(userSessionStateSelector);

  const [showThankYou, setShowThankYou] = useState(false);
  const onTextBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSupportData((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    const { name, value } = e.target;
   // Prevent user from entering more than 500 characters
   if(name === "issueDescription" && value.length > 500){
      return;
   }
    setSupportData((prev) => ({ ...prev, [name]: value }));

  };

  useEffect(() => {
    console.log("User State info", userSessionState);
    setUserSessionInfo(userSessionState);
  }, [userSessionState]);

  const handleSubmit = async () => {
    // Validate form inputs
    if (!supportData.issueType ||
        !supportData.issueDescription
    ) {
      setError("All fields are required, including the rating.");
      return;
    }

    setError(""); // Clear any previous errors

    try {
      // Send data to the API
      const response = await axios.post(`${apiUrlBase}feedback/support-request`, {
        issueType: supportData.issueType,
        issueDescription: supportData.issueDescription,
        userId: userSessionInfo?.id, // Assuming userId is available in userSessionInfo
        userName: userSessionInfo?.name, // Assuming userName is available in userSessionInfo
        userEmail: userSessionInfo?.email, // Assuming userEmail is available in userSessionInfo
      });

      setShowThankYou(true);
      setTimeout(() => {
        setShowThankYou(false);
        console.log("Feedback submitted successfully:", response.data);
        //toast.success("Thank you for your feedback!");
        onClose(); // Close the form after successful submission
      }, 5000); // Show thank you message for 2 seconds
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to submit feedback. Please try again.");
      setError("Failed to submit feedback. Please try again.");
    }
  };

  const handleCancelButtonClick = () => {
    // Reset form data
    setSupportData({
      issueType: "",
      issueDescription: ""
    });
    setError("");
    onClose();
  };

  return (
    <div className="support-overlay">
      <div className="contact-support-popup">
        <button className="support-close-btn" onClick={onClose}>
          &times;
        </button>
        {!showThankYou ? (
          <>
            <div className="contact-support-header">
              <div className="support-icon-container">
                 <TrowelIcon src={supportIcon} width="1.2rem" height="1.2em" />
              </div>
             
              <div className="support-suheading">
                <span className="header-1">Contact Support</span>
                <span className="header-2">
                  We're here to help you
                </span>
              </div>
            </div>
            <div className="support-form">

              <div>
              <label> Type of issue or Feedback </label>
              <input type="text"
                name="issueType"
                className="input-text-box"
                placeholder="e.g., User Interface issue, Feature Request"
                value={supportData.issueType}
                onChange={onTextBoxChange}
              />
              </div>

              <div>
              <label> Description</label>
              <textarea
                name="issueDescription"
                className="input-text-box-multi-line"
                rows={8}
                placeholder="Please describe your issue in deail..."
                value={supportData.issueDescription}
                onChange={handleInputChange}
              ></textarea>
              <label className="remaining-chars"> {supportData.issueDescription.length}/500</label>
              </div>

            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="support-form-actions">
              <div className="submit-button" onClick={handleSubmit}>
                <TrowelIcon src={sendMessageIcon} width="1.2rem" height="1.2rem" className="send-message-icon"/>
                 Send Message
              </div>
              <div className="submit-button cancel" onClick={handleCancelButtonClick}>
                 Cancel
              </div>
            </div>
              <label className="information" onClick={onClose}>
               <TrowelIcon src={infoIcon} width="1.2rem" height="1.2rem" className="info-icon"/>
                Our support team will get back to you soon.
              </label>
           
          </>
        ) : (
          <div
            className="thank-you-message"
            style={{ textAlign: "center", padding: "2rem 1rem" }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>👍</div>
            <div style={{ fontWeight: "bold", fontSize: "1.3rem" }}>
              Thank you for reaching out!
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              Our support team will get back to you as soon as possible.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSupportForm;
